import { LinkButton } from "@/components/LinkButton";
import { Card } from "@/components/ui";
import { ReviewFlow } from "@/review/components/ReviewFlow";
import { DEMO_PAGE } from "@/review/demo";
import { START_CTA, START_HREF } from "./content";

/**
 * Left: the promise. Right: the real customer flow running on demo data (no network), so the
 * picture of the product is the product.
 */
export function Hero() {
  return (
    <section
      aria-labelledby="hero-title"
      className="mx-auto grid max-w-layout items-start gap-12 px-5 pb-20 pt-10 lg:grid-cols-[minmax(0,1fr)_420px] lg:gap-16 lg:pt-12"
    >
      <div className="max-w-xl lg:self-center">
        <h1
          id="hero-title"
          className="text-title-1 font-bold text-label-strong break-keep md:text-display-2"
        >
          <span className="block">후기를 사지 않아요.</span>
          <span className="block">쓰기 쉽게 만들 뿐이에요.</span>
        </h1>
        <p className="mt-6 max-w-md text-headline-1 font-regular text-label-neutral break-keep">
          손님이 겪은 사실을 몇 번 누르면 초안이 생기고, 손님이 고쳐서 자기 계정으로 직접 올려요.
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-3">
          <LinkButton to={START_HREF} size="large">
            {START_CTA}
          </LinkButton>
          <a
            href="#how"
            className="inline-flex min-h-12 items-center rounded-md px-4 text-body-1 font-semibold text-label-normal underline-offset-4 hover:underline"
          >
            어떻게 쓰이는지 보기
          </a>
        </div>
      </div>

      <figure className="w-full">
        <Card
          variant="shadow"
          padding={0}
          radius="var(--radius-2xl)"
          style={{ overflow: "hidden" }}
        >
          <div className="lg:max-h-[min(720px,calc(100dvh-160px))] lg:min-h-[480px] lg:overflow-y-auto px-5 pb-6 pt-6 sm:px-6">
            <ReviewFlow page={DEMO_PAGE} mode="demo" embedded />
          </div>
        </Card>
        <figcaption className="mt-3 text-label-1 text-label-neutral break-keep">
          손님이 보는 화면 그대로예요. 눌러 보세요. 예시 매장이라 아무것도 보내지 않아요.
        </figcaption>
      </figure>
    </section>
  );
}
